import { Component, ReactNode } from "react";
import { ContentPageContext } from "./context";
import {
  ContentPageItem,
  ContentPageItemCollection,
} from "services/entities/content";

interface ContentItemProps {
  code: string;
  placeholder?: ReactNode;
  children: (item: ContentPageItem) => ReactNode;
}

export default class ContentItem extends Component<ContentItemProps, any> {
  static contextType = ContentPageContext;

  shouldComponentUpdate(
    nextProps: Readonly<ContentItemProps>,
    nextState: Readonly<{}>,
    nextContext: any
  ): boolean {
    return this.props.code !== nextProps.code || nextContext !== this.context;
  }

  render() {
    if (this.context === null) {
      return null;
    }
    const contentItem: ContentPageItem | undefined = this.getContent();
    if (contentItem === undefined) {
      return this.props.placeholder || null;
    }
    return this.props.children(contentItem);
  }

  getContent(): ContentPageItem | undefined {
    if (!this.props.code) {
      return undefined;
    }
    const codeParts = this.props.code.split(".");
    let contentItem: ContentPageItem | undefined = this.context.items;
    for (const code of codeParts) {
      if (contentItem === undefined) {
        return undefined;
      }
      contentItem = (contentItem as ContentPageItemCollection)[code];
    }
    return contentItem;
  }
}
